import * as Constants from '@emi/shared/constants';
import * as moment from 'moment';

export class DateRange {
  constructor(
    public startDate?: Date | null,
    public endDate?: Date | null
  ) {}

  public static getDefaultDateRange(maxDate: Date): DateRange {
    const startAndEndDayOffset = 1;
    const defaultDaysAgo = Constants.DatePicker.DEFAULT_SELECTED_DAYS_AGO - startAndEndDayOffset;
    const defaultStartDate = moment(maxDate).subtract(defaultDaysAgo, 'days').toDate();
    const defaultEndDate = moment(maxDate).toDate();

    return new DateRange(defaultStartDate, defaultEndDate);
  }

  public static isEqualDateRange(rangeA: DateRange, rangeB: DateRange): boolean {
    if (!rangeA?.startDate || !rangeA?.endDate || !rangeB?.startDate || !rangeB?.endDate) {
      return false;
    }

    return moment(rangeA.startDate).isSame(rangeB.startDate) && moment(rangeA.endDate).isSame(rangeB.endDate);
  }
}
